import { render, staticRenderFns } from "./account-dropdown.vue?vue&type=template&id=baa2a6a2&"
import script from "./account-dropdown.vue?vue&type=script&lang=js&"
export * from "./account-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports